// #region Vars
import { RequiredValidationRule } from "./rules/required.rule";
import { LengthValidationRule } from "./rules/length.rule";
import { MaxLengthValidationRule } from "./rules/maxlength.rule";
import { MinLengthValidationRule } from "./rules/minlength.rule";
import { TypeValidationRule } from "./rules/type.rule";
import { RegExpValidationRule } from "./rules/regexp.rule";
import { EvalValidationRule } from "./rules/eval.rule";
// #endregion
export class FormsValidator {
    // #region Vars
    _Validator = new Map();
    // #endregion
    // #region Constructor
    constructor() {
        this.registerValidator(new RequiredValidationRule());
        this.registerValidator(new MinLengthValidationRule());
        this.registerValidator(new MaxLengthValidationRule());
        this.registerValidator(new LengthValidationRule());
        this.registerValidator(new TypeValidationRule());
        this.registerValidator(new RegExpValidationRule());
        this.registerValidator(new EvalValidationRule());
        //this.registerValidator(new EqualsValidationRule());        
        //this.registerValidator(new IsInValidationRule());
    }
    // #endregion
    // #region Boostrap
    registerValidator(validator) {
        this._Validator.set(validator.name, validator);
    }
    // #endregion
    // #region Core
    validate(field, rules, value, data) {
        // #region Vars
        let tIsEmpty = utils.isNullOrEmpty(value);
        // #endregion
        // #region Run
        if (rules) {
            for (let tRule of rules) {
                // #region Check
                if (tRule.ifHasValue && tIsEmpty) {
                    continue;
                }
                // #endregion
                // #region Validator
                if (!this._Validator.has(tRule.name)) {
                    return {
                        isValid: false,
                        isCritical: false,
                        showAsMessage: false,
                        message: `Der Validierer "${tRule.name}" wurde nicht gefunden.`,
                    };
                }
                // #endregion
                // #region Validate
                let tResult = this._Validator.get(tRule.name).validate(field, tRule, value, data);
                // #endregion
                if (!tResult.isValid) {
                    return {
                        isValid: false,
                        isCritical: tRule.isCritical,
                        showAsMessage: tRule.showAsMessage,
                        message: tResult.message
                    };
                }
            }
        }
        // #endregion
        return {
            isValid: true,
            isCritical: false,
            showAsMessage: false
        };
    }
}
